// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class BeaconService {
   api: any
   beaconData: any
   genericValues: any
   http: any
   constructor(api: any, http: any) {
      this.update = this.update.bind(this)
      this.sendRawData = this.sendRawData.bind(this)
      this.sendData = this.sendData.bind(this)
      this.saveGenericValues = this.saveGenericValues.bind(this)
      this.api = api
      this.http = http
      this.beaconData = null
      // 'T' param is required for beacon requests
      this.genericValues = ['A', 'I', 'S', 'SRVR', 'P', 'OP', 'T', 'O8']
      this.api.on('update', this.update)
   }

   update(data: any) {
      if (data.beacon_data) {
         const rawData = atob(data.beacon_data) + "T=" + data._elapsedTime
         // save generic values to be used later
         this.saveGenericValues(rawData)
         return this.sendRawData(rawData)
      }
   }

   sendRawData(beaconRequest: any) {
      return this.http.post('/beacon', btoa(beaconRequest))
   }

   sendData(eventData: any) {
      if (!this.beaconData) { return }
      _.extend(this.beaconData, eventData)
      const params = _.map(this.beaconData, (val: any, key: any) => `${key}=${val}`).join('&')
      return this.sendRawData(params)
   }

   saveGenericValues(data: any) {
      return this.beaconData = _.chain(data.split('&'))
         .map((param: any) => {
            const [key, value] = param.split('=')
            if (this.genericValues.includes(key)) { return [key, value] }
         })
         .compact()
         .object()
         .value()
   }
}

BeaconService.$inject = ['apiService', '$http']

angular.module('summonApp.services')
   .service('beaconService', BeaconService)
